const Sounds = {
  alert: require('./alert.mp3'),
  ticket: require('./ticket.mp3'),
  alertChat: require('./chatNotification.mp3')
};
export default Sounds;
